import { createElementBlock as o, openBlock as t, createElementVNode as e } from "vue";
import n from "./index289.js";
const c = {}, r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function a(s, l, i, f, p, v) {
  return t(), o("svg", r, l[0] || (l[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#FFF9D5",
        d: "M43.432 38.231C40.84 44.548 34.626 49 27.364 49 17.774 49.002 10 41.24 10 31.665c0-9.068 6.977-16.499 15.862-17.261-4.423 6.078-3.908 14.624 1.583 20.105 4.326 4.32 10.558 5.548 15.987 3.722Z"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M25.756 13.159C16.169 13.98 8.75 22.002 8.75 31.665c0 10.266 8.335 18.588 18.614 18.585a18.61 18.61 0 0 0 17.225-11.544c.406-.991-.54-2.001-1.555-1.66-5.128 1.725-10.822.456-14.706-3.421-4.993-4.985-5.568-12.834-1.455-18.485.63-.867-.05-2.073-1.117-1.981Zm-2.368 2.924-.071.144c-3.055 6.303-1.902 14.03 3.244 19.167l.271.264A16.793 16.793 0 0 0 40.96 40.11l.127-.021-.066.109a16.11 16.11 0 0 1-13.657 7.552c-8.9.002-16.114-7.201-16.114-16.085 0-7.469 5.125-13.807 12.138-15.582Zm23.112.588c.647 0 1.18.492 1.244 1.122l.006.128v2.25H50a1.25 1.25 0 0 1 .128 2.494L50 22.67h-2.25v2.25a1.25 1.25 0 0 1-2.494.128l-.006-.128v-2.25H43a1.25 1.25 0 0 1-.128-2.493L43 20.17h2.25v-2.25c0-.69.56-1.25 1.25-1.25ZM36.014 8.092c.647 0 1.18.492 1.244 1.122l.006.128v1.25h1.25a1.25 1.25 0 0 1 .128 2.494l-.128.006h-1.25v1.25a1.25 1.25 0 0 1-2.493.128l-.007-.128v-1.25h-1.25a1.25 1.25 0 0 1-.128-2.493l.128-.007h1.25v-1.25c0-.69.56-1.25 1.25-1.25Z"
      })
    ], -1)
  ]));
}
const h = /* @__PURE__ */ n(c, [["render", a]]);
export {
  h as default
};
